module.exports = __webpack_public_path__ + "media/country_flags/ae-465276d0.png";